import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndividualEditorMainComponent } from './individual-editor-main/individual-editor-main.component';
import { EventsModule } from '../common/events/events.module';
import { IndividualEditorComponent } from './individual-editor/individual-editor.component';
import { ImageCarouselTempModule } from '../common/image-carousel-temp/image-carousel-temp.module';
import { CommonComponentModule } from '../common/common.module';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { IndividualPromptComponent } from './individual-prompt/individual-prompt.component';
import { MediaCarouselModule } from '../common/media-carousel/media-carousel.module';



@NgModule({
  declarations: [IndividualEditorMainComponent, IndividualEditorComponent, IndividualPromptComponent],
  imports: [
    CommonModule,
    EventsModule,
    ImageCarouselTempModule,
    MediaCarouselModule,
    CommonComponentModule,
    FormsModule,
    SharedModule    
  ],
  exports:[IndividualEditorMainComponent,IndividualPromptComponent]
})
export class IndividualeditorModule { }


// translation loader moved to SharedModule
